var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-card", { staticStyle: { height: "100% !important" } }, [
        _c(
          "div",
          {
            staticClass: "layout row wrap",
            staticStyle: { "padding-right": "0px", "padding-left": "10px" }
          },
          [
            _c(
              "div",
              { staticClass: "flex xs6 sm3 md3" },
              [
                _c(
                  "v-flex",
                  { attrs: { sm10: "", md10: "" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Plataformas",
                        items: _vm.lista_plataformas,
                        clearable: ""
                      },
                      on: { change: _vm.get_dropdowns },
                      model: {
                        value: _vm.model_plataformas,
                        callback: function($$v) {
                          _vm.model_plataformas = $$v
                        },
                        expression: "model_plataformas"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex xs6 sm3 md3" },
              [
                _c(
                  "v-flex",
                  { attrs: { sm10: "", md10: "" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Flotas",
                        items: _vm.lista_flotas,
                        "item-text": "desc",
                        "item-value": "cod",
                        clearable: ""
                      },
                      model: {
                        value: _vm.model_flotas,
                        callback: function($$v) {
                          _vm.model_flotas = $$v
                        },
                        expression: "model_flotas"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex xs6 sm3 md3" },
              [
                _c(
                  "v-flex",
                  { attrs: { sm10: "", md10: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        "prepend-icon": "search",
                        color: "primary",
                        label: "Buscar"
                      },
                      model: {
                        value: _vm.model_search,
                        callback: function($$v) {
                          _vm.model_search = $$v
                        },
                        expression: "model_search"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { sm3: "", md3: "" } },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleBuscarClick } },
                  [
                    _c("v-icon", [_vm._v("search")]),
                    _vm._v("Buscar\n        ")
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "layout row wrap",
            staticStyle: { "padding-right": "0px", "padding-left": "10px" }
          },
          [
            _c("div", { staticClass: "flex xs6 sm3 md2" }),
            _c("div", { staticClass: "flex xs6 sm3 md2" }, [
              _c("div", { staticClass: "text-sm-center botones-filtros" })
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "ag-grid-comp" },
          [
            _c("MantenedorGridSinCodigo", {
              attrs: {
                "grid-options": _vm.gridOptions,
                "funcionalidad-id": _vm.funcionalidad,
                verCheckboxColumna: false
              }
            })
          ],
          1
        )
      ]),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalCONFIRMAR,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.Modal_confirmar_TEXTO,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _vm.ModalEditar
        ? _c("modalEditar", {
            attrs: {
              show: _vm.ModalEditar,
              IDVEHICULO: _vm.ID_VEHICULO_SELECCIONADO,
              PATENTE: _vm.ID_PATENTE_SELECCIONADO,
              LOGINCODE: _vm.LOGINCODE_SELECCIONADO,
              NOMFLOTA: _vm.FLOTA_SELECCIONADO,
              GRUPOVEHICULO: _vm.GRUPOVEHICULO_SELECCIONADO,
              PLATAFORMA: _vm.PLATAFORMA
            },
            on: {
              modalverDetalleEmit: function($event) {
                return _vm.ModalEditar_callback($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }